import { Add } from '@mui/icons-material';
import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Actions, Subjects } from '../../services/ability';
import ActionsBar from '../ActionsBar/ActionsBar';
import Permission from '../Permission';
import styles from './InterventionsActions.module.scss';

export default function InterventionsActions() {
    const navigate = useNavigate()
    return (
        <ActionsBar>
            <Grid container justifyContent="flex-between" alignItems="center" className={styles.Wrapper}>
                <Grid item xs={6} container alignContent="center">
                    <Typography variant="h3" color="primary">Intervenções</Typography>
                </Grid>
                <Grid item xs={6} container justifyContent="flex-end">
                    <Permission action={Actions.CREATE} subject={Subjects.INTERVENTION}>
                        <Tooltip title="Criar intervenção">
                            <IconButton onClick={() => navigate("/create-intervention")}>
                                <Add />
                            </IconButton>
                        </Tooltip>
                    </Permission>
                </Grid>
            </Grid>
        </ActionsBar>
    )
}
